import { motion } from "framer-motion";

const moods = [
  {
    id: "side-eye",
    name: "The Side Eye",
    img: "/lint_side_eye.webp",
    quote: "Another feature? Let's first look at the problems already here.",
  },
  {
    id: "deep-dive",
    name: "The Deep Dive",
    img: "/lint_deep_dive.webp",
    quote: "That works for 100 users. Let's see what happens at 50,000.",
  },
  {
    id: "approval-nod",
    name: "The Approval Nod",
    img: "/lint_nod.webp",
    quote: "Clean architecture. You're good to go.",
  },
  {
    id: "companion",
    name: "The Everyday Companion",
    img: "/lint_books.webp",
    quote: "Better questions. Better products. I'm here every day.",
  },
];

export function MeetLint() {
  return (
    <section id="meet-lint" className="scroll-mt-8 bg-cream py-20 sm:py-28" data-testid="meet-lint">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <div className="max-w-2xl">
          <p className="text-sm font-semibold uppercase tracking-[0.16em] text-brand">Meet Lint</p>
          <h2 className="font-display mt-3 text-3xl font-semibold tracking-tight text-navy sm:text-5xl">
            Gentle on you. Honest about your code.
          </h2>
          <p className="mt-4 text-base leading-relaxed text-ink-muted sm:text-lg">
            Lint has seen a thousand products break in the same quiet ways. He
            won&apos;t flatter a bad assumption, but he&apos;ll never leave you
            without a way forward.
          </p>
        </div>
        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {moods.map((m, i) => (
            <motion.article
              key={m.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: i * 0.08, ease: "easeOut" }}
              className="group flex flex-col rounded-3xl border border-border bg-surface-elevated p-5 transition-transform duration-300 hover:-translate-y-1"
              data-testid={`lint-mood-${m.id}`}
            >
              <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-ink-muted">{m.name}</p>
              <div className="flex h-44 items-end justify-center">
                <img
                  src={m.img}
                  alt={`Lint: ${m.name}`}
                  className="max-h-40 w-auto transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <p className="font-display mt-4 text-lg leading-snug text-navy">&ldquo;{m.quote}&rdquo;</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
